var lib_core  = require("lib-core");
var MasterController = require("../master/masterController");
var ConnectionMessageView  = require("./connectionMessageView.js");

var ConnectionMessageController = function(archLayers, dependencies, options) {
    lib_core.Controller.call(this, archLayers, dependencies, options);
};
lib_core.inherit(ConnectionMessageController, lib_core.Controller);
ConnectionMessageController.inject = {
    masterController : MasterController
};

module.exports = ConnectionMessageController;

ConnectionMessageController.prototype.createView = function () {
    return new ConnectionMessageView(this.root, this.masterController.getView());
};
